import React from 'react';
import './WhyChooseUs.css';

function WhyChooseUs() {
  const features = [
    {
      icon: '🎯',
      title: 'Expert Team',
      description: 'Our team consists of highly skilled professionals with expertise in the latest technologies and industry best practices.'
    },
    {
      icon: '⚡',
      title: 'Fast Delivery',
      description: 'We follow agile methodologies to ensure quick turnaround times without compromising on quality.'
    },
    {
      icon: '💡',
      title: 'Innovative Solutions',
      description: 'We stay ahead of the curve by implementing cutting-edge technologies and creative approaches.'
    },
    {
      icon: '🛡️',
      title: 'Quality Assurance',
      description: 'Rigorous testing and quality checks ensure that every product we deliver meets the highest standards.'
    },
    {
      icon: '🤝',
      title: 'Client-Centric Approach',
      description: 'Your success is our priority. We work closely with you to understand and meet your specific needs.'
    },
    {
      icon: '📞',
      title: '24/7 Support',
      description: 'Our dedicated support team is always available to assist you with any queries or issues.'
    }
  ];

  return (
    <section id="why-choose-us" className="why-choose-us">
      <div className="container">
        <div className="section-header">
          <h2>Why Choose Us</h2>
          <div className="underline"></div>
          <p className="section-subtitle">
            Discover what makes CloudShift Technologies the perfect partner for your digital journey
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
